import { Navigate } from 'react-router-dom';
import { DEFAULT_AUTHENTICATED_ROUTE } from '@/constants/routes';

/**
 * Redirects authenticated users away from auth pages (login, register, etc.)
 * If a returnUrl exists in sessionStorage, redirect there instead of default route.
 */
export default function AuthenticatedRedirect() {
  const returnUrl = sessionStorage.getItem('returnUrl');

  if (returnUrl) {
    sessionStorage.removeItem('returnUrl');
    return <Navigate to={returnUrl} replace />;
  }

  return <Navigate to={DEFAULT_AUTHENTICATED_ROUTE} replace />;
}
